import { Link } from 'react-router-dom';
import { useState, useEffect } from 'react';
import Api from '../api/api';
import arrayUtilities from '../../utilities/arrayUtilities';
import { AllSitesSummaries } from '../enforcement/allSitesSummaries';
import Loader from '../shared/loader';
import roleUtilities from '../../utilities/roleUtilities';
import stringHelpers from '../../utilities/stringHelpers';
import { ErrorModal } from '../../utilities/errorModal';
import { SuccessModal } from "../shared/successModal";
import { WarningModal } from "../shared/warningModal";
import { Modal, Popover, OverlayTrigger } from 'react-bootstrap';
import { SearchBarWithDebounce } from '../shared/searchBarWithDebounce';
import { FiltersModalTrigger } from '../shared/filtersModalTrigger';
import { AppliedFilterPill, renderTagFilterItemLabel } from '../shared/appliedFilterPill';
import appliedFiltersUtilities from '../../utilities/appliedFiltersUtilities';
import { BreachesFiltersModal } from './breachesFiltersModal';
function BreachesDashboard(props) {

    const [sites, setSites] = useState(null);

    const [type, setType] = useState(null);
    const [status, setStatus] = useState([0]);
    const [search, setSearch] = useState("");
    const [filterEnd, setFilterEnd] = useState(null);
    const [filterStart, setFilterStart] = useState(null);
    const [isAssigned, setIsAssigned] = useState(null);
    const [selectedTags, setSelectedTags] = useState([]);
    const [showFiltersModal, setShowFiltersModal] = useState(false);
    const [showFilterPills, setShowFilterPills] = useState(false);
    const [appliedFilters, setAppliedFilters] = useState(null);

    const [canRedo, setCanRedo] = useState(false)
	const [showRedoModal, setShowRedoModal] = useState(false);
    const [showVoidModal, setShowVoidModal] = useState(false);
	const [note, setNote] = useState("");
	const [voidErrorMessage, setVoidErrorMessage] = useState(null)
	const [voidSuccessMessage, setVoidSuccessMessage] = useState(null)
    const [voidWarningMessage, setVoidWarningMessage] = useState(null)
    const [isSelectAllChecked, setIsSelectAllChecked] = useState(false);
	const [multiSelectList, setMultiSelectList] = useState([])
	const [errorMessage, setErrorMessage] = useState(null)
    const [voidReasons, setVoidReasons] = useState(null)
    const [voidReason, setVoidReason] = useState("")
    const [siteSummaries, setSiteSummaries] = useState([]);
    const [isLoadingSummaries, setIsLoadingSummaries] = useState(false)
    const [firstPageLoad, setFirstPageLoad] = useState(true)
    const [isRedoing, setIsRedoing] = useState(false)
    //breach numbers
    const [ticketsOpen, setTicketsOpen] = useState(null);
    const [ticketsAllocated, setTicketsAllocated] = useState(null);
    const [ticketsAllocatedToYou, setTicketsAllocatedToYou] = useState(null);

    var _breachesAllocatedAbortController = null;
    var _breachesOpenAbortController = null;
    var _breachesOwnedAbortController = null;

    const clearFilters = function () {
        setStatus([0]);
        setType(null);
        setFilterStart(null);
        setFilterEnd(null);
        setIsAssigned(null);
        setSelectedTags([]);
        setAppliedFilters(null);
        setShowFilterPills(false);
        getSitesSummaries(search, null, null, null, null, [])
    };

    const clearFilterByLabel = (label) => {
        switch (label) {
            case "Type":
                setType(null)
                getSitesSummaries(search, filterStart, filterEnd, null, isAssigned, selectedTags)
                break
            case "Allocation":
                setIsAssigned(null)
                getSitesSummaries(search, filterStart, filterEnd, type, null, selectedTags)
                break
            case "From":
                setFilterStart(null)
                getSitesSummaries(search, null, filterEnd, type, isAssigned, selectedTags)
                break
            case "To":
                setFilterEnd(null)
                getSitesSummaries(search, filterStart, null, type, isAssigned, selectedTags)
                break
            case "Date Range":
                setFilterStart(null)
                setFilterEnd(null)
                getSitesSummaries(search, null, null, type, isAssigned, selectedTags)
                break
            case "Tags":
                setSelectedTags([])
                getSitesSummaries(search, filterStart, filterEnd, type, isAssigned, [])
                break
            default:
                break
        }
    }

    const handleFilterPillClose = closedLabel => {
        clearFilterByLabel(closedLabel)
        setAppliedFilters(prevState => {
            const updatedFilters = { ...prevState }
            if (closedLabel === "From" || closedLabel === "To" || closedLabel === "Date Range") {
                updatedFilters.From = null
                updatedFilters.To = null
                updatedFilters["Date Range"] = null
            } else {
                updatedFilters[closedLabel] = null
            }
            return appliedFiltersUtilities.hasRemainingFilters(updatedFilters) ? updatedFilters : null
        })
    }

    const handleFilterPillItemRemove = (label, remainingIds) => {
        setAppliedFilters(prevState => appliedFiltersUtilities.keepMultiSelectionItems(prevState, label, remainingIds))
        removeMultiSelectFilterItemByLabel(label, remainingIds)
    }

    const removeMultiSelectFilterItemByLabel = (label, remainingIds) => {
        switch (label) {
            case "Tags":
                setSelectedTags(remainingIds)
                getSitesSummaries(search, filterStart, filterEnd, type, isAssigned, remainingIds)
                break
            default:
                break
        }
    }

    const getSites = function () {
        Api.getSites(
            (data) => setSites(data),
            (error) => console.log(error),
            props.organisationId,
            props.token
        )
    };

    const getBreachNumbers = function () {
        //tickets open
        if(_breachesOpenAbortController){
            _breachesOpenAbortController.abort();
        }
        _breachesOpenAbortController = new AbortController();
        const signal = _breachesOpenAbortController.signal;
        Api.getBreaches(
            (data) => setTicketsOpen(data),
            (error) => console.log(error),
            null, null, null, null, null, null, null, [0], null, 0, 0, null, null, null, null, null, null, props.organisationId, props.token, signal
        )
        //tickets allocated
        if(_breachesAllocatedAbortController){
            _breachesAllocatedAbortController.abort();
        }
        _breachesAllocatedAbortController = new AbortController();
        const signal2 = _breachesAllocatedAbortController.signal;
        Api.getBreaches(
            (data) => setTicketsAllocated(data),
            (error) => console.log(error),
            null, null, null, true, null, null, null, [0], null, 0, 0, null, null, null, null, null, null, props.organisationId, props.token, signal2
        )
        //allocated to you
        if(_breachesOwnedAbortController){
            _breachesOwnedAbortController.abort();
        }
        _breachesOwnedAbortController = new AbortController();
        const signal3 = _breachesOwnedAbortController.signal;
        Api.getBreaches(
            (data) => {
                setTicketsAllocatedToYou(data)
            },
            (error) => console.log(error),
            null, null, props.user.id, true, null, null, null, [0], null, 0, 0, null, null, null, null, null, null, props.organisationId, props.token, signal3
        )
    };

    const getSitesSummaries = (queryString, start, end, contraventionType, isAssignedValue, tagIds) => {
        setIsLoadingSummaries(true)
        Api.getAllSitesSummaries(
            data => {
                setSiteSummaries(data)
                setIsLoadingSummaries(false)
                setFirstPageLoad(false)
            },
            error => {
                console.log(error)
                setIsLoadingSummaries(false)
                setFirstPageLoad(false)
            },
            queryString,
            start,
            end,
            contraventionType,
            [0],
            null,
            null,
            isAssignedValue,
            null,
            null,
            tagIds,
            props.organisationId,
            props.token,
        );
    };

    const getVoidReasons = () => {
        Api.getVoidReasons(
            (data) => setVoidReasons(data),
            (error) => console.log(error),
            props.organisationId,
            props.token
        )
    }

    useEffect(() => {
        getSites();
        getBreachNumbers();
        getSitesSummaries(search, filterStart, filterEnd, type, isAssigned, selectedTags);
        getVoidReasons()
    }, []);


    const allocatedUrl = "/organisation/" + props.organisationId + "/allocated-breaches"

    const handleMultiVoidConfirm = () => {
        setShowVoidModal(false);
        Api.voidMultipleTickets(
            data => {
                if (data.isError) {
                    setVoidErrorMessage(data.errorMessage)
                }
                else {
                    if (data.length > 0) {
                        setVoidSuccessMessage(`${data.length } ${data.length > 1 ? "breaches" : "breach"} voided successfully`)
                    } else {
                        setVoidWarningMessage("No breaches were updated")
                    }
                    getSitesSummaries(search, filterStart, filterEnd, type, isAssigned, selectedTags)
                    setMultiSelectList([]);
                    setNote("");
                }
            },
            error => {
                console.log(error)
                setVoidErrorMessage(error.errorMessage)
            },
            multiSelectList, !stringHelpers.isNullOrEmpty(voidReason) ? voidReason : null, !stringHelpers.isNullOrEmpty(note) ? note : "ticket voided", props.organisationId, props.token)
    }

    const handleRemoveAndRedo = () => {
        setIsRedoing(true)
        setShowRedoModal(false)
        Api.deleteBreaches(
            props.organisationId, multiSelectList,
            data => {
                if (data.isError) {
                    setIsRedoing(false)
                    setErrorMessage(data.errorMessage)
                }
                else {
                    setIsRedoing(false)
                    setErrorMessage(null)
                    getSitesSummaries(search, filterStart, filterEnd, type, isAssigned, selectedTags);
                    setCanRedo(false)
                    setMultiSelectList([])
                    setIsSelectAllChecked(false)
                }
            },
            error => {
                setIsRedoing(false)
                setErrorMessage(error.message)
            },
            props.token
        )
    }

    const isThirdPartyUser = roleUtilities.isThirdPartyProcessor(props.user, props.organisationId) || roleUtilities.isThirdPartyManager(props.user, props.organisationId)

    return (        
        <div className="container-fluid">
            <div className="row">
                { firstPageLoad ? <Loader />
                    : <>
                        <div className="col-12">
                            <div className="card mb-3">
                                <div className="card-header">
                                    <div className="row align-items-center justify-content-between">
                                        <div className="col-1 d-flex align-items-center pr-0">
                                            <h5 className="fs-0 mb-0 text-nowrap py-2 py-xl-0">Breaches Dashboard</h5>
                                        </div>
                                        {!isThirdPartyUser && <div className="col-auto">
                                            <Link to={{
                                                pathname: `/organisation/${props.organisationId}/allocate`,
                                                state: {
                                                    isAssigned: null
                                                }
                                            }}>
                                                <button className="btn btn-primary btn-sm mr-2">Re-Allocate</button>
                                            </Link>
                                            <Link to={{
                                                pathname: `/organisation/${props.organisationId}/allocate`,
                                                state: {
                                                    isAssigned: false
                                                }
                                            }}>
                                                <button className="btn btn-primary btn-sm">Allocate</button>
                                            </Link>
                                        </div>}
                                    </div>
                                </div>
                            </div>
                        </div>
                        {!isThirdPartyUser && !roleUtilities.isOrganisationProcessor(props.user, props.organisationId) && 
                        <>
                        <div className="col-4">
                            <div className="card mb-3">
                                <div className="card-header">
                                    <div className="row align-items-center justify-content-between">
                                        <div className="col-12 d-flex align-items-center pr-0">
                                            <h5 className="fs-0 mb-0 text-nowrap py-2 py-xl-0">Tickets Open</h5>
                                        </div>
                                    </div>
                                </div>
                                <div className="card-body bg-light border-top details-container">
                                    { ticketsOpen?.totalCount }
                                </div>
                            </div>
                        </div>
                        <div className="col-4">
                            <div className="card mb-3">
                                <div className="card-header">
                                    <div className="row align-items-center justify-content-between">
                                        <div className="col-8 d-flex align-items-center pr-0">
                                            <h5 className="fs-0 mb-0 text-nowrap py-2 py-xl-0">Tickets Allocated for Processing</h5>
                                        </div>
                                    </div>
                                </div>
                                <div className="card-body bg-light border-top details-container">
                                    { ticketsAllocated?.totalCount }
                                </div>
                            </div>
                        </div>
                        <div className="col-4">
                            <Link to={ allocatedUrl } className="no-hover">
                                <div className="card mb-3">
                                    <div className="card-header">
                                        <div className="row align-items-center justify-content-between">
                                            <div className="col-8 align-items-center pr-0">
                                                <h5 className="fs-0 mb-0 text-nowrap py-2 py-xl-0">Tickets Allocated to you</h5>
                                            </div>
                                            <div className="col-3 mr-1 d-flex justify-content-end">
                                                <div className="btn btn-falcon-default btn-sm mb-0 dummy-button">Go</div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="card-body bg-light border-top details-container">
                                        { ticketsAllocatedToYou?.totalCount }
                                    </div>
                                </div>
                            </Link>
                        </div></>}
                        
                        <div className="col-12">
                            <div className="mb-3">
                                <div className="card-header">
                                    <div className="row align-items-center justify-content-between">
                                        <div className="col-1 d-flex align-items-center pr-0">
                                            <h5 className="fs-0 mb-0 text-nowrap py-2 py-xl-0">Tickets</h5>
                                        </div>
                                        <div className="col-auto d-flex align-items-center pl-0">
                                            <div className='mr-2'>
                                                <SearchBarWithDebounce
                                                    onSearchQueryChange={query => {
                                                        setSearch(query)
                                                        getSitesSummaries(query, filterStart, filterEnd, type, isAssigned, selectedTags)
                                                    }}
                                                />
                                            </div>
                                            <div className='mr-2'>
                                                <FiltersModalTrigger onClick={ () => setShowFiltersModal(true) } />
                                            </div>
                                            <button className="btn btn-primary btn-sm mr-1 ml-1 nowrap" onClick={ () => getSitesSummaries(search, filterStart, filterEnd, type, isAssigned, selectedTags)}><i className="fas fa-redo"></i> Refresh</button>
                                            {
                                                roleUtilities.isOrganisationAdmin(props.user, props.organisationId) && !isThirdPartyUser && !roleUtilities.isOrganisationProcessor(props.user, props.organisationId) &&
                                                    <OverlayTrigger trigger="hover" placement='left' overlay={<Popover className='redo-popover'><p className='m-0 p-2'>Remove the breach and reset the parking sessions so they can be re-processed in the next batch tomorrow morning</p></Popover>}>
                                                        <div className='d-flex align-items-center'>   
                                                            <button
                                                                disabled={!canRedo}
                                                                className="btn btn-primary btn-sm col-auto ml-2 text-nowrap"
                                                                onClick={() => setShowRedoModal(true)}>
                                                                <i className="fas fa-undo"></i> Remove and re-do
                                                            </button>
                                                        </div>
                                                    </OverlayTrigger>
                                            }
                                            {
                                                !roleUtilities.isThirdPartyProcessor(props.user, props.organisationId) && !roleUtilities.isOrganisationProcessor(props.user, props.organisationId) && 
                                                <button
                                                    disabled={ arrayUtilities.isNullOrEmpty(multiSelectList) }
                                                    className="btn btn-danger btn-sm text-nowrap ml-2"
                                                    onClick={ () => setShowVoidModal(true) }>
                                                    <i className="fas fa-times"></i> Void
                                                </button>
                                            }
                                        </div>
                                    </div>
                                </div>
                                {
                                    showFilterPills && appliedFilters &&
                                    <div className="px-3 py-2 border-top d-flex align-items-center flex-wrap">
                                        {
                                            Object.entries(appliedFilters).map(
                                                ([label, value]) => <AppliedFilterPill
                                                    key={ label }
                                                    label={ label }
                                                    value={ value }
                                                    renderItemLabel={ renderTagFilterItemLabel }
                                                    onTextClick={ () => setShowFiltersModal(true) }
                                                    onCloseClick={ handleFilterPillClose }
                                                    onRemoveItem={ handleFilterPillItemRemove }
                                                />
                                            )
                                        }
                                        {appliedFilters && Object.keys(appliedFilters).length > 0 && <button type="button" className="btn btn-none p-0 m-0 fs--1 nowrap" onClick={() => clearFilters()}>Clear all filters</button>}
                                    </div>
                                }
                                {
                                    (
                                        <AllSitesSummaries
                                            isLoadingSummaries={isLoadingSummaries}
                                            isRedoing={isRedoing}
                                            statuses={ status }
                                            type={ type }
                                            filterEnd={ filterEnd }
                                            filterStart={ filterStart }
                                            searchQuery={ search }
                                            isOnHold={ null }
                                            isAssigned={isAssigned}
                                            tagIds={ selectedTags }
                                            siteSummaries={ siteSummaries }
                                            organisationId={ props.organisationId }
                                            token={ props.token }
                                            setCanRedo={setCanRedo}
                                            isSelectAllChecked={isSelectAllChecked}
                                            setIsSelectAllChecked={setIsSelectAllChecked}
                                            multiSelectList={multiSelectList}
                                            setMultiSelectList={setMultiSelectList}
                                        />
                                    )
                                }
                            </div>
                        </div>
                    </>
                }
            </div>
            <Modal show={showRedoModal} onHide={() => setShowRedoModal(false)}>
				<Modal.Header>
					<Modal.Title>
						Remove and re-do
					</Modal.Title>
				</Modal.Header>
				<Modal.Body>
					Are you sure you want to remove and re-do {multiSelectList.length === 1 ? <>this ticket</> : <>these {multiSelectList.length} tickets</>}?
				</Modal.Body>
				<Modal.Footer>
					<button
						className="btn btn-sm btn-danger mt-1"
						onClick={() => setShowRedoModal(false)}
					>
						Cancel
					</button>
					<button
						className="btn btn-sm btn-success mt-1"
						onClick={handleRemoveAndRedo}
					>
						Confirm
					</button>
				</Modal.Footer>
			</Modal>
            {
                showVoidModal &&
                <Modal show onHide={ () => { setShowVoidModal(false); setVoidReason(""); setNote("") } }>
                    <Modal.Header>
                        <Modal.Title>
                            Void multiple breaches.
                        </Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <div className="row mb-2">
							<div className="col-12 ">
								<p className="font-weight-semi-bold  mt-1 mb-1">Reason:</p>
							</div>
							<div className="col-12">
								<div className="form-group mb-0">
									<select
										id="void-reason-selector"
										className="border rounded py-1 px-2 w-100"
										onChange={ (e) => setVoidReason(e.target.value) }
										value={ voidReason }
									>
										<option value="">Select a reason</option>
										{ voidReasons?.map(item => <option value={ item.id }>{ item.name }</option>) }
									</select>
								</div>
							</div>
						</div>
                        <div className="row">
                            <div className="col-12 ">
                                <p className="font-weight-semi-bold  mt-1 mb-2">Note:</p>
                            </div>
                            <div className="col-12">
                                <div className="form-group mb-0">
                                    <textarea className="form-control mb-0" rows={ 4 } value={ note } onChange={ (e) => setNote(e.target.value) } />
                                </div>
                            </div>
                        </div>
                    </Modal.Body>
                    <Modal.Footer>
                        <button
                            className="btn btn-sm btn-danger mt-1"
                            onClick={ () => { setShowVoidModal(false); setVoidReason(""); setNote("") } }
                        >
                            Cancel
                        </button>
                        <button
                            className="btn btn-sm btn-success mt-1"
                            onClick={ handleMultiVoidConfirm }
                        >
                            Confirm
                        </button>
                    </Modal.Footer>
                </Modal>
            }
			{!stringHelpers.isNullOrEmpty(errorMessage) && <ErrorModal key="remove-redo-error" message={errorMessage} onHide={() => setErrorMessage(null)} />}
            {!stringHelpers.isNullOrEmpty(voidErrorMessage) && <ErrorModal key="void-error" message={voidErrorMessage} onHide={() => setVoidErrorMessage(null)} />}
            {!stringHelpers.isNullOrEmpty(voidSuccessMessage) && <SuccessModal message={voidSuccessMessage} onHide={() => setVoidSuccessMessage(null)} />}
            {!stringHelpers.isNullOrEmpty(voidWarningMessage) && <WarningModal message={voidWarningMessage} onHide={() => setVoidWarningMessage(null)} />}
            {
                showFiltersModal &&
                <BreachesFiltersModal
                    showModal={showFiltersModal}
                    handleClose={() => setShowFiltersModal(false)}
                    handleConfirm={(draftFilters) => {
                        setFilterStart(draftFilters.filterStart)
                        setFilterEnd(draftFilters.filterEnd)
                        setType(draftFilters.type)
                        setIsAssigned(draftFilters.isAssigned)
                        setSelectedTags(draftFilters.selectedTags)
                        setAppliedFilters(draftFilters.appliedFilters)
                        setShowFilterPills(true)
                        setShowFiltersModal(false)
                        getSitesSummaries(search, draftFilters.filterStart, draftFilters.filterEnd, draftFilters.type, draftFilters.isAssigned, draftFilters.selectedTags)
                    }}
                    initialFilterStart={filterStart}
                    initialFilterEnd={filterEnd}
                    initialType={type}
                    initialIsAssigned={isAssigned}
                    initialSelectedTags={selectedTags}
                    initialAppliedFilters={appliedFilters}
                    tags={props.tags || []}
                    showIsAssignedFilter={!isThirdPartyUser && !roleUtilities.isOrganisationProcessor(props.user, props.organisationId)}
                    key="breaches-dashboard-filters-modal"
                />
            }
        </div>
    )
}

export default BreachesDashboard;